import {
  CHANGE_PASSWORD_DIALOG_OPEN,
  CURRENT_PASSWORD,
  CURRENT_PASSWORD_IS_VALID,
  FIRSTNAME,
  LASTNAME,
  loadProfile,
  NEW_PASSWORD,
  NEW_PASSWORD_CONFIRM,
  NEW_PASSWORD_CONFIRM_IS_VALID,
  NEW_PASSWORD_IS_VALID,
  propertyChange,
  saveProfile,
  updatePassword
} from "../../../ducks/userProfile";

import UserProfile from "./UserProfile";
import { bindActionCreators } from "redux";
import { clearMessages } from "../../../ducks/message";
import { connect } from "react-redux";
import { LOGIN_STORE, USER_PROFILE } from "../../../common/constant";

const mapStateToProps = (state) => {
  return {
    firstname: state[USER_PROFILE][FIRSTNAME],
    lastname: state[USER_PROFILE][LASTNAME],
    hasChanged:
      state[USER_PROFILE][FIRSTNAME] !== state[LOGIN_STORE][FIRSTNAME] ||
      state[USER_PROFILE][LASTNAME] !== state[LOGIN_STORE][LASTNAME],
    currentPassword: state[USER_PROFILE][CURRENT_PASSWORD],
    currentPasswordIsValid: state[USER_PROFILE][CURRENT_PASSWORD_IS_VALID],
    newPassword: state[USER_PROFILE][NEW_PASSWORD],
    newPasswordIsValid: state[USER_PROFILE][NEW_PASSWORD_IS_VALID],
    newPasswordConfirm: state[USER_PROFILE][NEW_PASSWORD_CONFIRM],
    newPasswordConfirmIsValid: state[USER_PROFILE][NEW_PASSWORD_CONFIRM_IS_VALID],
    changePasswordDialogOpen: state[USER_PROFILE][CHANGE_PASSWORD_DIALOG_OPEN]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveProfile,
      propertyChange,
      loadProfile,
      updatePassword,
      clearMessages
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
